<template>
  <div class="login">
   <component v-bind:is="layout"></component>
    
  </div>
</template>

<script>
export default {
    name: 'Ssowsologout',
    components:{
        
    },
    computed: {
      layout () {
        var themename='ThemeMDB'
        return () => import('@/components/'+themename+'/ssowsologout')
      }
  }

};
</script>